<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="核查记录"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />

    <div style="padding:15px">

      <span style="font-size: 15px;color:#808695;font-weight: bold">本地待提交核查记录</span>

      <van-tag color="#ecf9ff" text-color="#1989fa" style="margin-left: 8px">本地缓存限制2条，默认保留最新记录</van-tag>

      <van-list v-model="loading1" :finished="finished1" finished-text="没有更多了"
        :immediate-check="false" style="margin-top: 10px">

        <div v-for="(item,index) in localCacheList" :key="index" class="record">
          <div style="padding:0 20px;border-bottom:1px solid #EBEEF5;">
            <div class="typeTxt">
              <span>{{ item.signTime }}</span>
              <van-button style="float: right;border-radius: 10px;padding: 0 15px" @click="localCacheDelete(item.id)"
                          type="danger" size="mini">删除</van-button>

              <van-button style="float: right;border-radius: 10px;padding: 0 12px;margin-right: 10px" @click="syncCloudCache(item)"
                          type="info" size="mini">同步到云端</van-button>
            </div>

            <van-row class="infoRow" align="center" @click="detailSignIn(item,0)">
              <van-col>企业名称：</van-col>
              <van-col>{{ item.companyAlias }}</van-col>
            </van-row>
            <van-row class="infoRow" @click="detailSignIn(item,0)">
              <van-col span="24" style="line-height:30px;">签到地点：</van-col>
              <van-col style="line-height:20px;">{{ item.signAddress }}<br>(<span>{{ item.lng }}</span><span
                style="margin-left:10px;">{{ item.lat }}</span>)
              </van-col>
            </van-row>
          </div>
        </div>

      </van-list>

      <span style="font-size: 15px;color:#808695;font-weight: bold">云端待提交核查记录</span>

      <van-list v-model="loading2" :finished="finished2" finished-text="没有更多了"
                :immediate-check="false" style="margin-top: 10px">

        <div v-for="(item,index) in cloudCacheList" :key="index" class="record">
          <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
            <div class="typeTxt">
              <span>{{ item.signTime }}</span>

              <van-button style="float: right;border-radius: 10px;padding: 0 15px" @click="cloudCacheDelete(item.cacheCode)"
                          type="danger" size="mini">删除
              </van-button>
            </div>

            <van-row class="infoRow" align="center" @click="detailSignIn(item,2)">
              <van-col>企业名称：</van-col>
              <van-col>{{ item.companyAlias }}</van-col>
            </van-row>
            <van-row class="infoRow" @click="detailSignIn(item,2)">
              <van-col span="24" style="line-height:30px;">签到地点：</van-col>
              <van-col style="line-height:20px;">{{ item.signAddress }}<br>(<span>{{ item.lng }}</span><span
                style="margin-left:10px;">{{ item.lat }}</span>)
              </van-col>
            </van-row>
          </div>
        </div>

      </van-list>

      <span style="font-size: 15px;color:#808695;font-weight: bold">核查记录</span>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了"
        :immediate-check="false" style="margin-top: 10px">

        <div v-for="(item,index) in recordsList" :key="index" class="record">
          <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
            <div class="typeTxt">
              <span>{{ item.signTime }}</span>

              <van-button style="float: right;border-radius: 10px;padding: 0px 15px" @click="deleteWorkRecords(item.id)"
                          type="danger" size="mini">删除
              </van-button>
            </div>
            <van-row class="infoRow" align="center" @click="detailSignIn(item,1)">
              <van-col>企业名称：</van-col>
              <van-col>{{ item.companyName }}</van-col>
            </van-row>
            <van-row class="infoRow" @click="detailSignIn(item,1)">
              <van-col span="24" style="line-height:30px;">签到地点：</van-col>
              <van-col style="line-height:20px;">{{ item.signAddress }}<br>(<span>{{ item.lng }}</span><span
                style="margin-left:10px;">{{ item.lat }}</span>)
              </van-col>
            </van-row>
            <!--            <van-row v-if="item.signPhotosId" class="infoRow">-->
            <!--              <van-col span="24" style="line-height:30px;">现场照片：</van-col>-->
            <!--              <van-col span="7">-->
            <!--                <img :src="apiUrl + 'download/' + item.signPhotosId" @click="showSignPhoto(item.signPhotosId)"/>-->
            <!--              </van-col>-->
            <!--            </van-row>-->
            <!--            <van-row v-else class="infoRow">-->
            <!--              <van-col>现场照片：</van-col>-->
            <!--              <van-col>无</van-col>-->
            <!--            </van-row>-->

            <!--            <van-row v-if="item.appendix.length>0" class="infoRow">-->
            <!--              <van-col span="24">核查材料：</van-col>-->
            <!--              <van-col span="24">-->
            <!--                <van-row type="flex" style="flex-flow:row wrap;">-->
            <!--                  <van-col span='7' v-for="(appendix,i) in item.appendix" :key="i"-->
            <!--                           style="margin-top:5px;margin-right:10px;">-->
            <!--                    <img style="height:80px;width:100%;" :src="apiUrl + 'download/' + appendix.attachmentId"-->
            <!--                         @click="showAppendixPhoto(item.appendix,i)"/>-->
            <!--                  </van-col>-->
            <!--                </van-row>-->
            <!--              </van-col>-->
            <!--            </van-row>-->
            <!--            <van-row v-else class="infoRow">-->
            <!--              <van-col>核查材料：</van-col>-->
            <!--              <van-col>无</van-col>-->
            <!--            </van-row>-->
          </div>
        </div>

      </van-list>
    </div>

  </div>
</template>
<script>
import $ from '@/fly'
import Setting from '@/setting';
import Vue from 'vue';
import {ImagePreview, Toast, Dialog} from 'vant';
import {WorkRecordCheckItemRemarksStore, WorkRecordsStore} from "@/libs/indexedDB";

Vue.use(ImagePreview);
export default {
  name: 'project-workRecords',
  data() {
    return {
      clientHeight: window.screen.height,
      recordsList: [],
      loading: false,
      finished: false,
      loading1: false,
      finished1: false,
      loading2: false,
      finished2: false,
      apiUrl: Setting.apiBaseURL,
      localCacheList: [],
      cloudCacheList: [],
      companyIdCache: null,
      projectIdCache: null,
    }
  },
  computed: {},
  methods: {
    //删除本地缓存
    localCacheDelete(id) {
       Dialog.confirm({
        title: '提示',
        message: '是否要删除当前待提交记录？',
      }).then(() => {
         WorkRecordsStore.delete(id)
         WorkRecordCheckItemRemarksStore.delete(id)
         this.getLocalCache()
         Toast.success('删除成功');
      })
    },
    //同步到云端
    syncCloudCache(localCacheData) {
      Dialog.confirm({
        title: '提示',
        message: '是否要将本地暂存同步云端？',
      }).then(async () => {
        if (!navigator.onLine) {
          throw new Error('无网络连接，无法同步云端')
        }
        const cacheRemarks = (await WorkRecordCheckItemRemarksStore.toArray())
          .find(record => record.id === localCacheData.id)

        const remarks = {
          id: cacheRemarks.id,
          remarks: JSON.parse(cacheRemarks.remarks)
        }
        $.put('workRecords/cacheCloud', {
          workRecords: JSON.stringify(localCacheData),
          remarksList: JSON.stringify(remarks),
        }, {contentType: 'application/json'}).then(() => {
          WorkRecordsStore.delete(localCacheData.id)
          WorkRecordCheckItemRemarksStore.delete(localCacheData.id)
          this.getLocalCache()
          this.getCloudCache()
          Toast.success('同步成功！');
        }).catch(err => {
          Toast.fail(err.message);
        })
      })
    },
    //删除云端缓存
    cloudCacheDelete(cacheCode) {
      Dialog.confirm({
        title: '提示',
        message: '是否要删除当前待提交记录？',
      }).then(() => {
        $.delete('/workRecords/delCloudCacheByCode',{
          projectId: this.projectIdCache,
          companyId: this.companyIdCache,
          cacheCode: cacheCode
        }).then(() => {
          Toast.success('删除成功');
          this.getCloudCache()
        }).catch(error => {
          console.log(error)
        })
      })
    },
    //核查信息缓存及记录 0 本地缓存 2 云端缓存 1 记录
    detailSignIn(item, index) {
      localStorage.setItem('isCacheWork',index)
      if(index===0){
        localStorage.setItem('indexdbCacheId',item.id)
      } else if (index===2){
        localStorage.setItem('cloudCacheCode',item.cacheCode)
      } else {
        localStorage.setItem('workRecordItem',JSON.stringify(item))
      }
      this.$router.push({name: 'project-companyVerification'});
    },
    //删除核查记录
    deleteWorkRecords(id) {
      Dialog.confirm({
        title: '提示',
        message: '是否要删除当前核查记录？',
      }).then(() => {
          $.delete('/workRecords/' + id).then(() => {
            Toast.success('删除成功');
            this.getWorkRecords()
          }).catch(error => {
            console.log(error)
          })
        })
    },

    showSignPhoto(id) {
      ImagePreview({
        images: [
          Setting.apiBaseURL + 'download/' + id
        ],
        closeable: true
      });
    },

    showAppendixPhoto(appendixs, index) {
      var imageArr = [];
      appendixs.forEach(appendix => {
        imageArr.push(Setting.apiBaseURL + 'download/' + appendix.attachmentId);
      });
      ImagePreview({
        images: imageArr,
        startPosition: index,
        closeable: true
      });
    },
    //获取核查记录数据
    getWorkRecords() {
      $.get('workRecords/getByProjectCompany', {
        projectIds: this.projectIdCache,
        companyIds: this.companyIdCache
      }).then(res => {
        this.recordsList = res;
        this.loading = false;
        this.finished = true;
      })
    },
    //获取本地缓存记录
    async getLocalCache() {
      this.localCacheList = (await WorkRecordsStore.toArray())
        .filter(record => record.projectId == this.projectIdCache && record.companyId == this.companyIdCache)
        .sort((f, s) => s.id - f.id)
      this.loading1 = false
      this.finished1 = true
    },
    //获取云端缓存记录
    getCloudCache() {
      $.get('/workRecords/getCloudCacheList', {
        projectId: this.projectIdCache,
        companyId: this.companyIdCache
      }).then(res => {
        this.cloudCacheList = res
          .map(record => ({ ...JSON.parse(record.workRecords) }))
          .sort((a, b) => new Date(b.signTime).getTime() - new Date(a.signTime).getTime())
        this.loading2 = false;
        this.finished2 = true;
      }).catch(error => {
        console.log(error)
      })
    },
  },
  created() {
    this.projectIdCache = localStorage.getItem('projectId')
    this.companyIdCache = localStorage.getItem('companyId')
    this.getWorkRecords()
    this.getLocalCache()
    this.getCloudCache()
  }
}

</script>

<style lang="less" scoped>
.record {
  background-color: #FFFFFF;
  margin-bottom: 20px;
}

.typeTxt {
  font-size: 30px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding: 25px 0px 15px 0px;
  letter-spacing: 1px;
}

.typeTxt span {
  width: 5px;
  //background-color:#50C9FF;
  //display:inline-block;
  height: 34px;
  vertical-align: middle;
}

.infoRow {
  padding: 20px 5px;
  font-size: 26px;
  font-weight: bold;
}

.infoRow .van-col:nth-child(1) {
  color: #999999;
}

.picture {
  width: 30%;
}
</style>
